
























































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Shared types
import { Texts } from '@coldtec/cos-types';

// Store types
import { CompanyGetter, SpacesConfigData, ToolSpace } from '@/store/store.types';

// Internal space components
import SpaceActions from './SpaceActions.vue';
import SpaceContentInput from './SpaceContentInput.vue';
import SpaceSummary from './SpaceSummary.vue';

/**
 *  Holding the details of a dimension that
 *  is needed to compute the contents.
 */
interface Dimension {
    /**
     *
     *  The direction of the dimension.
     *
     *  (!) Must be equal to a property of the space.
     *
     */
    direction: 'length' | 'width' | 'height';

    /** Label to show besides the input */
    label: string;

    /** The unit to use/show in the content input. */
    unit: string;
}

/**
 *  An added space, including the contents, radios, checkboxes.
 */
@Component({
    components: {
        SpaceActions,
        SpaceContentInput,
        SpaceSummary,
    },
})
export default class Space extends Vue {

    @Prop({ type: Object, required: true })
    private toolSpace!: ToolSpace;

    /**
     *  Holding the dimensions to compute the contents.
     */
    private dimensions: Array<Dimension> = [
        {
            direction: 'length',
            label: 'Lengte',
            unit: 'm',
        },
        {
            direction: 'width',
            label: 'Breedte',
            unit: 'm',
        },
        {
            direction: 'height',
            label: 'Hoogte',
            unit: 'm',
        },
    ];

    /**
     *  Used to get the data that is used to configure a space.
     */
    private get configData(): SpacesConfigData {

        return this.$store.state.spaces.configData;

    }

    /**
     *  Used to get the correct title for the toggle
     *  action, based on the open state of the space.
     */
    private get toggleTitle(): string {

        return `${ this.toolSpace.open ? 'Sluit' : 'Open' } ${ this.toolSpace.data.name }`;

    }

    /**
     *  Used to determine if the user selected "different" as
     *  floor, which is true if the selected floor holds
     *  `null` in his `floor` prop.
     */
    private get differentFloor(): boolean | null {

        return !this.toolSpace.data.floor
            ? null
            : this.toolSpace.data.floor === 'ccos-static-guid-floor-different-cco';

    }

    /**
     *  Used to get all the texts of the company.
     */
    private get companyTexts(): Texts {

        return this.$store.getters[CompanyGetter.TEXTS];

    }

    /**
     *  Used to compute the space's contents in cubic meter.
     */
    private computeCubicMeter(): void {

        const values: Array<number> = [];

        for (const dimension of this.dimensions) {

            values.push(this.toolSpace.data[dimension.direction] || 0);

        }

        /**
         *  Multiply every dimension to get the contents.
         */
        this.toolSpace.data.contents = values.reduce((prev: number, cur: number) => prev * cur, 1);

        /**
         *  Round the number to one decimal place.
         */
        this.toolSpace.data.contents = Math.round(this.toolSpace.data.contents * 10) / 10;

        this.$emit('update');

    }

    /**
     *  Used to reset the dimensions when the cubic
     *  meter has been set by the user.
     */
    private cubicMeterSet(): void {

        for (const dimension of this.dimensions) {

            this.toolSpace.data[dimension.direction] = null;

        }

        this.$emit('update');

    }

}
